import { Route, Routes, useLocation } from "react-router";
import Home from "./pages/Home";
import { AnimatePresence } from "framer-motion";
import PageContainer from "./pages/PageContainer";
import Kurumsal from "./pages/Kurumsal";
import Sektorler from "./pages/Sektorler";
import SirketHaberleri from "./pages/SirketHaberleri";
import SektorelGelismeler from "./pages/SektorelGelismeler";
import Detail from "./components/Detail";
import Iletisim from "./pages/Iletisim";
import Hizmetlerimiz from "./pages/Hizmetlerimiz";
import { useEffect, useLayoutEffect } from "react";
import ReactLenis from "lenis/react";
import SirketHaberleriDetail from "./pages/SirketHaberleriDetail";
import SektorelGelismelerDetail from "./pages/SektorelGelismelerDetail";
import NedenGenesis from "./pages/neden-genesis-trade-lojistik";
import Guncelleniyor from "./components/upt/Guncelleniyor";


function App() {
  const location = useLocation();



  return (

    <ReactLenis root>
      <div className="App  bg-white">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>

            <Route path="/" element={<PageContainer />} >
              <Route path="/" element={<Home />} />
              <Route path="/kurumsal" element={<Kurumsal />} />

              <Route path="/hizmetler/:id1" element={<Hizmetlerimiz />} />

              <Route path="/sektorler/:id1" element={<Sektorler />} />

              <Route path="/iletisim" element={<Iletisim />} />

              <Route path="/guncelleniyor" element={<Guncelleniyor />} />
              <Route path="/neden-genesis-trade-lojistik" element={< NedenGenesis/>} />


              <Route path="/haberler">
                <Route path="sirket-haberleri" element={<SirketHaberleri />} >

                </Route>



                <Route path="sirket-haberleri/:id1" element={<SirketHaberleriDetail />}> </Route>


                <Route path="sektorel-gelismeler" element={<SektorelGelismeler />}>

                </Route>



                <Route path="sektorel-gelismeler/:id1" element={<SektorelGelismelerDetail />} ></Route>





              </Route>


            </Route>
          </Routes>
        </AnimatePresence>
      </div >
    </ReactLenis>
  );
}

export default App;
